import { render, staticRenderFns } from "./SetupStepsSidebar.vue?vue&type=template&id=86ae469e&scoped=true&"
import script from "./SetupStepsSidebar.vue?vue&type=script&lang=js&"
export * from "./SetupStepsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SetupStepsSidebar.vue?vue&type=style&index=0&id=86ae469e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ae469e",
  null
  
)

export default component.exports